import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';

export const ConnectorPromoSidebarLoader: LoadableType<{ isNav4?: boolean }> = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ConnectorPromoSidebar" */ './ConnectorPromoSidebar.ts'
			)
		).ConnectorPromoSidebar,
});
